import { ChangeDetectionStrategy, Component, ViewEncapsulation, afterNextRender, signal } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ProductTradingSetConfiguratorWidgetComponent } from '../product-trading-set-configurator-widget/product-trading-set-configurator-widget.component';

@Component({
  selector: 'app-formly-product-trading-set-configurator',
  templateUrl: './formly-product-trading-set-configurator.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ProductTradingSetConfiguratorWidgetComponent,
  ]
})
export class FormlyProductTradingSetConfiguratorComponent extends FieldType {

  productId = signal<string>(null);

  constructor() {
    super();

    afterNextRender(() => {
      if (this.formControl.value)
        this.productId.set(this.formControl.value);
      this.form.valueChanges.subscribe((x: any) => {
        //productId
        if (this.productId() != x.id) {
          this.productId.set(x.id);
          console.log('trading set change');
        }
      });
    });
  }

}
